/**
 * Created by Ning Jiang on 5/14/2019.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {IReelDividerConfig, StaticReelDivider} from "@nolimitcity/slot-game/bin/game/reeldivider/StaticReelDivider";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";

export class PPReelDivider extends StaticReelDivider {

    constructor(config:IReelDividerConfig) {
        super(config);
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:GameEvent) => this.onBeforeSpinStart());
    }

    private onBeforeSpinStart():void {
        (<TimelineSprite[]>this._dividers).forEach((divider:TimelineSprite) => {
            divider.getAnimation();
        });
    }
}